import React, { useRef, useEffect, useState, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import SearchBarContainer from '../../containers/SearchContainers/SearchBarContainer'
import { ActionButtonContainer } from '../../containers/ToolsContainers/ToolsContainers'

import { SEARCH_VIEW } from '../../actions/viewmode'
import { ROUTES } from '../../constants'

import { LayerBox } from '../DeliverablesComponents/LayerBox'
import { DeliverableItem } from '../DeliverablesComponents/DeliverableItem'
import ToggleSearchBarContainer from '../../containers/TopBar/ToggleSearchBarContainer'
import styled from 'styled-components'
import SearchBarFiltersAndListContainer from '../../containers/SearchContainers/SearchBarFiltersAndListContainer'
import { initializeViewerGeometries } from '../../actions/initialization'
import { useSelector } from 'react-redux'
import { UIStyles, surfaces } from '../../theme'

export const AdvancedFiltersWrapper = styled.div`
  display: flex;
`

const SearchWrapper = styled.div`
  position: absolute;
  background-color: ${UIStyles.blueColorOpacity};
  -webkit-backdrop-filter: ${surfaces.glassBackdropFilter};
  backdrop-filter: ${surfaces.glassBackdropFilter};
  box-shadow: ${surfaces.dockedPanelShadow};
  height: calc(100vh - 60px);
  left: 0;
  right: 0;
  top: 100%;
  z-index: 10000;
`

const BottonsWrapper = styled.div`
  display: flex;
`

const SearchView = ({
  isPageReady,
  prospectLayers,
  isFocus,
  hasDeleted,
  isSearchView,
  onToggleVisibility,
  onToggleLayer,
  onChangeOpacity,
  t,
  currentLocation,
  totalFieldCount,
  initializeSearchFilter
}) => {
  const isViewerSearchReady = useSelector(state => state.config.initializationQueries.viewer.REQUEST_GEOMETRIES)

  const WrapperRef = useRef(null)

  function setWrapperRef(node) {
    WrapperRef.current = node
  }

  const currentView = currentLocation.view
  const currentRoute = currentLocation.route

  const [originalFieldCount, setOriginalFieldCount] = useState()

  const isSearchBarVisible =
    (totalFieldCount !== undefined && isViewerSearchReady && currentView === SEARCH_VIEW) ||
    (totalFieldCount !== undefined && currentRoute === ROUTES.DASHBOARD_ROUTE)

  useEffect(() => {
    if (!totalFieldCount && !isPageReady) {
      initializeSearchFilter()
    }
  }, [initializeSearchFilter, totalFieldCount, isPageReady])

  useLayoutEffect(() => {
    if (!isViewerSearchReady && currentView === SEARCH_VIEW) {
      initializeViewerGeometries()
    }
  }, [currentView, isViewerSearchReady])

  useEffect(() => {
    if (!originalFieldCount) {
      setOriginalFieldCount(totalFieldCount)
    }
  }, [totalFieldCount, originalFieldCount])

  return isPageReady ? (
    <>
      <div ref={setWrapperRef} className={`searchListContainer ${isFocus ? 'withFocus' : ''}`}>
        <SearchBarContainer isVisible={isSearchBarVisible} fieldCount={originalFieldCount}>
          <ToggleSearchBarContainer />
          <BottonsWrapper>
            <ActionButtonContainer testIdCrossBtn="clear-fields-button" />
          </BottonsWrapper>
          {isFocus && (
            <SearchWrapper>
              <SearchBarFiltersAndListContainer totalFieldCount={totalFieldCount} />
            </SearchWrapper>
          )}
        </SearchBarContainer>
      </div>
      {hasDeleted && <div className="deleteNotify">{t('Your field has been successfully deleted.')}</div>}
      <div className="layerBoxes">
        <LayerBox
          layers={prospectLayers}
          renderLayer={(layer, index) => (
            <DeliverableItem
              idx={index}
              index={index}
              key={index}
              deliverable={layer.deliverable}
              isTemporal={false}
              toggleVisibility={() => onToggleVisibility(layer)}
              toggleDeliverable={() => onToggleLayer(layer)}
              changeOpacity={opacity => onChangeOpacity(layer, opacity)}
            />
          )}
          visible={isSearchView}
        />
      </div>
    </>
  ) : null
}

SearchView.propTypes = {
  filters: PropTypes.object,
  hasDeleted: PropTypes.bool,
  isFocus: PropTypes.bool,
  currentLocation: PropTypes.object,
  totalFieldCount: PropTypes.number
}

export default SearchView
